import { splitBySearchPhrases } from "@repo/utils";
import classnames from "classnames";

export const splitAndColorTextBySearchPhrases = (name, searchPhrases, defaultText) => (
  name && searchPhrases?.length > 0
    ? splitBySearchPhrases(name?.replace(/<(.|\n)*?>/g, ""), searchPhrases)?.map(({ value, isSearchPhrase }, i) => (
      <span key={value+i} className={classnames(isSearchPhrase && "marker")}>
        {value}
      </span>
    ))
    : name?.replace(/<(.|\n)*?>/g, "") || defaultText
)